export default "__VITE_ASSET__CHY6iFsE__"